export const PagePackState = {
  ONLY_DRAFT_VERSION: 'onlyDraftVersion',
  PUBLISHED_WITH_DRAFT_VERSION: 'publishedWithDraftVersion',
  ONLY_PUBLISHED_VERSION: 'onlyPublishedVersion',
} as const;

export type PagePackStates = (typeof PagePackState)[keyof typeof PagePackState];
